const link = {
  /** 底部菜单 **/
  footer_001: '/support/article?code=11675575132753921',
  footer_002: '/support/article?code=11675575189901313',
  footer_003: '/support/notice',
  footer_004: '/support/index',
  /** 注册-用户协议 **/
  footer_005: '/support/article?code=11675574997487617',
  footer_006: '/support/article?code=11675575043100673',
  footer_007: '/support/article?code=11675575085043713',
  /**问题反馈 **/
  footer_008: 'https://hotcoinhelp.zendesk.com/hc/zh-cn/requests/new',

  // nft项目申请中文、英文
  nft_project_application_zh: 'https://docs.google.com/forms/d/1lSl3bi0QYlVMNMyeR7QOmyko95YRM1S7SzYDCMsjadc/edit',
  nft_project_application_en: 'https://docs.google.com/forms/d/1Iw7PQRi6Dk0XK5F3kDQRFOuY3E0y6t_-FXj4NhwLBZ0/edit',

  /** 头部公告 **/
  header_001: 'https://hotcoinhelp.zendesk.com/hc/zh-cn/articles/',
  header_002:
    'https://hotcoinhelp.zendesk.com/api/v2/help_center/zh-cn/sections/360003777513/articles.json?page=1&per_page=5',

  /** 合约指引 **/
  contract_info: '/support/article?code=11675154373808129&id=11675154373808128',
  /** 开通合约 **/
  contract_open: '/support/article?code=11675576226680833',
  /** 合约杠杆 **/
  contract_risk: '/support/article?code=11675576304537601',
  /** 合约币本位 **/
  contract_coin: '/support/article?code=11675576443473921',
  /** 合约金本位 **/
  contract_money: '/support/article?code=11711771719110657',

  /**了解合约委托类型信息 */
  contract_entrustmentType: '/support/article?code=22289446034345984',

  // 委托说明的跳转链接
  // 1、限价、市价、高级限价跳转
  spot_lever_entrust_type10: '/support/article?code=22921409007325184',
  // 2、跟踪委托跳转
  spot_lever_entrust_type3: '/support/article?code=22921618659086336',
  // 3、计划委托跳转
  spot_lever_entrust_type12: '/support/article?code=11675843891433473',

  /** 币币交易 eft协议 **/
  coin_etf_agreement: '/support/article?code=11675577498341377',

  /** 币币交易 最优档位计算公式 */
  coin_gear: '/support/article?code=11675862936457217',

  /** otc 新手教程 **/
  otc_course: '/support/article?code=11675561683193857',

  /** 商户申请 广告协议**/
  otc_merchant: '/support/article?code=11675584632328193',

  /**好友邀请的公告链接 */
  user_ic: '/support/article?code=11675839040196609',

  /**了解强平流程 */
  strong_flat: '/support/article?code=11675576732880897',

  /**了解usdt合约信息 */
  contract_usdt_newInfo: '/support/article?code=11675581307555841',

  /**了解币本位合约信息 */
  contract_coin_newInfo: '/support/article?code=11675581342420993',

  /**合约用户协议 */
  contract_user_agreement: '/support/article?code=11675576226680833',
  /**合约风险提示书 */
  contract_risk_reminder: '/support/article?code=11675575960342529',

  /**合约邀请具体规则 */
  contract_user_ic: '/support/article?id=14924483298988032&code=14924483298988033',

  /**Hotcoin服务协议 */
  financial_serve_agreement: '/support/article?code=11675956830670849',

  /**质押借币用户协议 */
  financial_pledge_borrowMoney: '/support/article?code=11728646031151105',

  /** 上币申请 */
  currency_application: 'https://docs.google.com/forms/d/1eLJK-V6Qx7atDz2yoWff3N3Dl4PcKzwjZ3IywXF_nmM/edit',
  /** 上币申请-英文 */
  currency_application_en: 'https://docs.google.com/forms/d/1kEGmp1hvkulaGynCkb66bNnw7wkNPCpGMX57xp2cBUY/edit',

  /**杠杆新手指引 杠杆使用说明 */
  lever_course: '/support/article?code=12830051107737601',
  /**杠杆用户协议 */
  lever_user_agreement: '/support/article?code=12829940008751105',
  /**杠杆风险率及强平规则 */
  lever_risk_flat: '/support/article?code=12830111807442945',

  /**NFT教程 */
  nft_deposit_course: '/support/article?code=15409315215183873',

  /**信用卡买币 教程 */
  c2c_creditCard_curriculum: '/support/article?code=15560327096569856',

  /**IEO 教程 */
  ieo_curriculum: '/support/article?code=16000888788094976',

  /**IEO 认购协议 */
  ieo_agreement: '/support/article?code=16000961538035712',

  /**信用卡买币 协议 */
  c2c_creditCard_argument: '/support/article?code=16394866248781824',

  /**双币理财 协议 */
  dual_agreement: '/support/article?code=16519321024073728',

  /**如何 双币理财*/
  dual_course: '/support/article?code=16519375271104512',

  /**交易员协议*/
  chargeback_trader: '/support/article?code=16907095443640320',
  /**跟单员协议*/
  chargeback_merchandiser: '/support/article?code=16907027089330176',
  /**跟单风险规则*/
  chargeback_risk: '/support/article?code=16906675904974848',
  /**跟单首页查看教程*/
  chargeback_course: '/support/article?code=16907635890982912',

  /**福利中心手续费折扣弹框查看详情*/
  benefits_contract_fee_voucher: '/support/article?code=17304295018991616',
  /**福利中心首页常见问题*/
  benefits_question: '/support/article?code=17304286870507520',
  /**支付首页-如何使用*/
  pay_index_how_use: '/support/article?code=17947873568231424',
  /**支付首页-如何使用*/
  pay_index_why: '/support/article?code=17947879393333248',

  // 首页 新手指引 充值数字货币
  home_guide_deposit: '/support/article?code=11675551133732865',
  // 首页 新手指引 合约教程
  home_guide_contract: '/support/article?code=11674793977188353',
  /**快捷买币-快捷买卖交易协议*/
  quick_trade_agreement: '/support/article?code=16394866248781824',

  // 安卓App下载教程
  android_app_download_tutorials: '/support/article?code=14653673505951745',
  // 苹果App下载教程
  apple_app_download_tutorials: '/support/article?code=11675551449092097',
  // 充值未到账
  recharge_not_arrived: '/support/article?code=18976786134208512',
  // 提现未到账
  withdrawal_not_arrived: '/support/article?code=18976788885671936',

  // 地址白名单
  address_white_list: '/support/article?code=19251774295248896',
}

export default link
